//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'GestaoAprovacaoTabela',
  props: {
    filtros: null,
  },
  data() {
    return {
      resourceFluxoExecucao: this.$api.workflowPassos(this.$resource),
      passos: [],
      totalPassos: 0,
      loading: false,
      pagination: {},
    };
  },
  watch: {
    filtros() {
      this.$forceUpdate();
      if (this.pagination.page === 1) {
        this.buscarPassos();
      } else {
        this.pagination.page = 1;
      }
    },
    pagination: {
      handler() {
        this.buscarPassos();
      },
      deep: true,
    },
  },
  computed: {
    tipoNaoSelecionado() {
      return !this.filtros.tipo || !this.filtros.tipo.id;
    },
    headers() {
      const isFilteringByAcordo = !!this.filtros.idAcordo;
      const headerText = isFilteringByAcordo
        ? this.$t('label.numero_acordo')
        : this.$t('label.tipo_de_fluxo');
      return [
        {
          text: headerText,
          sortable: false,
          value: 'tipo',
        },
        {
          text: this.$t('label.solicitante'),
          value: 'solicitante',
        },
        {
          text: this.$t('label.data_solicitacao'),
          value: 'dta_solicitacao',
        },
        {
          text: this.$t('label.aprovador_atual'),
          value: 'aprovador_atual',
        },
        {
          text: this.$tc('label.acoes', 2),
          align: 'center',
          sortable: false,
          value: '',
        },
      ];
    },
  },
  methods: {
    transferirTodos() {
      if (this.tipoNaoSelecionado) return;
      const passo = {
        tipo: this.filtros.tipo.nome,
        solicitante: this.filtros.solicitante ? this.filtros.solicitante.solicitante : null,
        usuarioAprovador: this.filtros.aprovador ? this.filtros.aprovador.aprovador : null,
        idAprovador: this.filtros.aprovador ? this.filtros.aprovador.id : null,
        tarefaAprovacao: this.filtros.passo.descricao,
        passocliente: this.filtros.passo.passocliente,
      };
      this.$emit('TransferirPasso', passo);
    },
    transferirPasso(passo) {
      passo.passocliente = this.filtros.passo.passocliente;
      passo.tarefaAprovacao = this.filtros.passo.descricao;
      this.$emit('TransferirPasso', passo);
    },
    buscarPassos() {
      if (this.tipoNaoSelecionado) return;
      this.loading = true;
      this.resourceFluxoExecucao.buscarPassos(this.preencherFiltro())
        .then((response) => {
          this.loading = false;
          this.passos = response.data.resposta;
          this.totalPassos = response.data.quantidadeRegistrosPagina;
        })
        .catch((err) => {
          this.$error(this, err);
          this.loading = false;
        });
    },
    preencherFiltro() {
      const filtro = {};
      const { sortBy, sortDesc, page, itemsPerPage } = this.pagination;
      if (this.filtros.aprovador && this.filtros.aprovador.id) {
        filtro.idAprovador = this.filtros.aprovador.id;
      }
      if (this.filtros.solicitante && this.filtros.solicitante.id) {
        filtro.idSolicitante = this.filtros.solicitante.id;
      }
      if (this.filtros.idAcordo) {
        filtro.idAcordo = this.filtros.idAcordo;
      }
      filtro.idTipo = this.filtros.tipo.id;
      filtro.passo = this.filtros.passo.descricao;
      filtro.passoCliente = this.filtros.passo.passocliente;
      filtro.numeroPagina = page;
      filtro.tamanhoPagina = itemsPerPage;
      filtro.colunaOrdenacao = sortBy[0];
      filtro.asc = !sortDesc[0];
      return filtro;
    },
  },
};



// WEBPACK FOOTER //
// ./src/spa/gestao-aprovacao/GestaoAprovacaoTabela.vue?vue&type=script&lang=js&